import { gql, TypedDocumentNode } from '@apollo/client'

import { AttributesDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const ATTRIBUTE_FRAGMENT: TypedDocumentNode<AttributesDTO> = gql`
  fragment abTestsVariantsAttributesFragment on AbTestsVariantsAttributes {
    label
    type
    value
    workspaceDefaultValue
  }
`
